/**
 * Converts a camelCase string to title case.
 *
 * @param camelCase - The camelCase string to convert.
 * @returns The title case string.
 */
// https://stackoverflow.com/a/35953318/2384326
export const camelToTitle = (camelCase: string) =>
    camelCase
        .replace(/(_)+/g, ' ')
        .replace(/([a-z])([A-Z][a-z])/g, '$1 $2')
        .replace(/([A-Z][a-z])([A-Z])/g, '$1 $2')
        .replace(/([a-z])([A-Z]+[a-z])/g, '$1 $2')
        .replace(/([A-Z]+)([A-Z][a-z][a-z])/g, '$1 $2')
        .replace(/([a-z]+)([A-Z0-9]+)/g, '$1 $2')
        .replace(/([A-Z]+)([A-Z][a-rt-z][a-z]*)/g, '$1 $2')
        .replace(/([0-9])([A-Z][a-z]+)/g, '$1 $2')
        .replace(/([A-Z]{2,})([0-9]{2,})/g, '$1 $2')
        .replace(/([0-9]{2,})([A-Z]{2,})/g, '$1 $2')
        .replace(/^./, (s) => s.toUpperCase())
        .trim()
